import ContentCard from "@/components/collection/ContentCard";

// Renders a collection's visible items + load-more + empty state.
// Keeps long lists clean by paginating instead of dumping everything at once.
export default function CollectionGrid({
  collection,
  onItemClick,
  columns = "md:grid-cols-2 lg:grid-cols-3",
  emptyLabel = "Nothing matches your search yet.",
  testidPrefix = "collection",
}) {
  const { visibleItems, hasMore, loadMore, reset, total } = collection;

  if (total === 0) {
    return (
      <div
        data-testid={`${testidPrefix}-empty`}
        className="text-center py-20 border border-white/10 bg-ink-surface"
      >
        <p className="text-zinc-400">{emptyLabel}</p>
        <button
          onClick={reset}
          data-testid={`${testidPrefix}-reset`}
          className="mt-4 text-burnt text-sm font-medium"
        >
          Clear filters
        </button>
      </div>
    );
  }

  return (
    <div>
      <div className={`grid grid-cols-1 ${columns} gap-6`}>
        {visibleItems.map((item, i) => (
          <ContentCard
            key={item.id}
            item={item}
            index={i}
            onClick={onItemClick}
          />
        ))}
      </div>

      {hasMore && (
        <div className="mt-12 text-center">
          <button
            onClick={loadMore}
            data-testid={`${testidPrefix}-load-more`}
            className="inline-flex items-center gap-2 border border-white/20 text-white font-medium px-8 py-3.5 hover:bg-white/5 hover:border-white transition-colors"
          >
            Load more
          </button>
        </div>
      )}
    </div>
  );
}
